import { VContextMenuContext } from './context';

export const useVContextMenuContext = VContextMenuContext.hook;
